var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 139,
    viewBox: "0 0 140 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 19.25H105C103.075 19.25 101.5 20.825 101.5 22.75C101.5 24.675 103.075 26.25 105 26.25H129.5C131.425 26.25 133 27.825 133 29.75V103.25C133 105.175 131.425 106.75 129.5 106.75H112V89.25C112 75.74 101.01 64.75 87.5 64.75H52.5C38.99 64.75 28 75.74 28 89.25V106.75H10.5C8.575 106.75 7 105.175 7 103.25V29.75C7 27.825 8.575 26.25 10.5 26.25H35C36.925 26.25 38.5 24.675 38.5 22.75C38.5 20.825 36.925 19.25 35 19.25H10.5C4.725 19.25 0 23.975 0 29.75V103.25C0 109.025 4.725 113.75 10.5 113.75H129.5C135.275 113.75 140 109.025 140 103.25V29.75C140 23.975 135.275 19.25 129.5 19.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 138.25C58.299 138.25 63 133.549 63 127.75C63 121.951 58.299 117.25 52.5 117.25C46.701 117.25 42 121.951 42 127.75C42 133.549 46.701 138.25 52.5 138.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 59.5C86.4305 59.5 99.75 46.1805 99.75 29.75C99.75 13.3195 86.4305 0 70 0C53.5695 0 40.25 13.3195 40.25 29.75C40.25 46.1805 53.5695 59.5 70 59.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126 124.25H66.01C66.29 125.37 66.5 126.525 66.5 127.75C66.5 128.975 66.29 130.13 66.01 131.25H126C127.925 131.25 129.5 129.675 129.5 127.75C129.5 125.825 127.925 124.25 126 124.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 124.25C12.075 124.25 10.5 125.825 10.5 127.75C10.5 129.675 12.075 131.25 14 131.25H38.99C38.71 130.13 38.5 128.975 38.5 127.75C38.5 126.525 38.71 125.37 38.99 124.25H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoReview);
export default __webpack_public_path__ + "static/media/video-review.c584028720ba06e6043682e1ebfba181.svg";
export { ForwardRef as ReactComponent };